import { IStoreState } from "Interfaces";

export const clientListSelector = (state: IStoreState) =>
  state.application.clients;
